import { Alert, Snackbar } from "@mui/material";
import React, { useState } from "react";

export const SuccessBar = ({ message, resetSuccess }) => {
  const [open, setOpen] = useState(true);

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={open}
        autoHideDuration={6000}
        onClose={() => {
          setOpen(false);
          resetSuccess(false);
        }}
      >
        <Alert
          onClose={() => setOpen(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          <div style={{ whiteSpace: "pre-line" }}>{message}</div>
        </Alert>
      </Snackbar>
    </div>
  );
};
